import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { MaterialModule } from '../../shared/modules';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderModule } from '../header/header.module';

@NgModule({
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
  imports: [CommonModule, MaterialModule, MatToolbarModule, HeaderModule]
})
export class NavbarModule {}
